import { Typography } from '@/components/ui/typography'
import { OGSM_COPY } from '@/features/ogsm/ogsm-labels'
import type { OgsmBoardNode } from '@/types/api'

/**
 * A bar and caption for how many of a node's strategies are on track. The two
 * halves are sized by `flex-grow`, so the browser does the proportion.
 */
export function StrategyProgress({ node }: { node: OgsmBoardNode }) {
  const { strategiesOnTrack, strategiesTotal } = node
  if (strategiesTotal === 0) return null
  return (
    <div className="flex min-w-48 flex-1 items-center gap-3">
      <div
        aria-hidden
        className="flex h-1.5 min-w-8 flex-1 overflow-hidden rounded-full bg-primary/10"
      >
        <span
          className="rounded-full bg-[repeating-linear-gradient(90deg,var(--color-status-on-track)_0_6px,transparent_6px_9px)]"
          style={{ flex: `${strategiesOnTrack} 1 0` }}
        />
        <span style={{ flex: `${strategiesTotal - strategiesOnTrack} 1 0` }} />
      </div>
      <Typography
        as="span"
        variant="body-sm"
        className="shrink-0 text-primary/60"
      >
        {OGSM_COPY.strategiesOnTrack(strategiesOnTrack, strategiesTotal)}
      </Typography>
    </div>
  )
}
